exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".product-presentation .desktoptext{padding-left:40px;text-align:left}.product-presentation .order-button-and-text{text-align:center;width:100%}.product-presentation button{margin:25px 0 50px}.product-presentation .productimage{width:90%;display:inline;max-width:400px}", "", {"version":3,"sources":["/home/bamboo/applications/bamboo-home/xml-data/build-dir/AAI-SCFR-JOB1/src/page-components/src/page-components/Product.scss"],"names":[],"mappings":"AAEA,mCAGI,kBACA,eAAgB,CAJpB,6CAQI,kBACA,UAAW,CATf,6BAaI,kBAAmB,CAbvB,oCAiBI,UACA,eACA,eAAgB,CACjB","file":"Product.scss","sourcesContent":["@import '../styles/colors';\n\n.product-presentation {\n\n  .desktoptext {\n    padding-left: 40px;\n    text-align: left;\n  }\n\n  .order-button-and-text {\n    text-align: center;\n    width: 100%;\n  }\n\n  button {\n    margin: 25px 0 50px;\n  }\n\n  .productimage {\n    width: 90%;\n    display: inline;\n    max-width: 400px;\n  }\n\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/sass-loader/lib/loader.js?sourceMap!./src/page-components/Product.scss
// module id = 1383
// module chunks = 0